// import hotkeys from "hotkeys-js"
import { showSpinner, showSavedCheck } from "./field_status"

window.IntumJs = {
  toggle: function(...targetIds) {
    targetIds.forEach(targetId => {
      const target = document.getElementById(targetId)
      if (target) {
        target.classList.toggle("hidden")
      }
    })
    return false
  },

  slugify: function(text) {
    return text
      .toLowerCase()
      .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-z0-9\s-]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-")
      .replace(/^-|-$/g, "")
  },

  // focus textarea and position cursor at end of specified line (1-indexed)
  focusAtEndOfLine: function(elementId, lineNumber) {
    const el = document.getElementById(elementId)
    if (!el) return

    el.focus()
    const lines = el.value.split("\n")
    let pos = 0
    for (let i = 0; i < Math.min(lineNumber, lines.length); i++) {
      pos += lines[i].length + (i < lineNumber - 1 ? 1 : 0)
    }
    el.setSelectionRange(pos, pos)
  },

  // auto-fill targetId with slugified value from sourceId
  setupSlugField: function(sourceId, targetId, options = {}) {
    const source = document.getElementById(sourceId)
    const target = document.getElementById(targetId)
    if (!source || !target) return

    let manuallyEdited = target.value.trim() !== ""
    const self = this

    const getPrefix = () => {
      if (!options.categoryUrlMap) return ""
      const catInput = document.querySelector(options.categorySelector || "[name*=category_id]")
      if (!catInput || !catInput.value) return ""
      const catUrl = options.categoryUrlMap[catInput.value]
      return catUrl ? catUrl + "/" : ""
    }

    const updateSlug = () => {
      if (!manuallyEdited) {
        target.value = getPrefix() + self.slugify(source.value)
      }
    }

    target.addEventListener("input", () => { manuallyEdited = true })
    source.addEventListener("input", updateSlug)

    // aktualizuj URL przy zmianie kategorii
    if (options.categorySelector) {
      const catInput = document.querySelector(options.categorySelector)
      if (catInput) catInput.addEventListener("change", updateSlug)
    }
  },

  // wyświetla notyfikację flash (success/error/warning)
  notify: function(message, type) {
    const el = document.getElementById("notification_flash")
    if (!el) return

    const icons = {
      error: "<svg class=\"h-6 w-6 text-red-500\" xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke=\"currentColor\" stroke-width=\"2\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z\"/></svg>",
      warning: "<svg class=\"h-6 w-6 text-yellow-500\" xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke=\"currentColor\" stroke-width=\"2\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z\"/></svg>",
    }
    const icon = icons[type] || "<svg class=\"h-6 w-6 text-green-400\" xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke=\"currentColor\" stroke-width=\"2\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z\"/></svg>"

    el.innerHTML = "<div data-controller=\"notification\" aria-live=\"assertive\" style=\"z-index:100\" class=\"fixed inset-0 flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start\"><div class=\"w-full flex flex-col self-end items-center space-y-4 sm:items-end\"><div class=\"max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1/5 ring-black overflow-hidden\"><div class=\"p-4\"><div class=\"flex items-start\"><div class=\"shrink-0\">" + icon + "</div><div class=\"ml-3 w-0 flex-1 pt-0.5\"><p class=\"text-sm font-medium text-gray-900\">" + message + "</p></div></div></div></div></div></div>"
  },

  // POST /account/set_field z feedbackiem
  // IntumJs.setField("key", value, { check: this })           — fajka obok elementu, znika po 1 s (ZALECANE — zawsze używaj check: this)
  // IntumJs.setField("key", value, { check: false })          — bez fajki
  // IntumJs.setField("key", value, { notify: "Zapisano" })    — notyfikacja flash (UWAGA: wyłącza kręciołek — unikaj w settings, używaj check: this)
  // IntumJs.setField("key", value, { target: "account" })     — zapis do account (domyślnie user_setting)
  setField: function(key, value, options) {
    const target = (options && options.target) || "user_setting"
    let url = "/account/set_field?target=" + encodeURIComponent(target) + "&key=" + encodeURIComponent(key) + "&value=" + encodeURIComponent(value)
    if (options && options.skip_cleanup) url += "&skip_cleanup=true"
    const csrfToken = document.querySelector("meta[name=csrf-token]")
    // domyślnie kręciołek, chyba że podano notify lub check: false
    const el = options && options.notify ? null : (options && options.check !== undefined ? options.check : (event && event.target) || null)
    let spinner

    // spinner obok elementu podczas zapisu
    if (el) {
      spinner = el.parentNode.querySelector(".intum-field-status")
      if (!spinner) {
        spinner = document.createElement("span")
        spinner.className = "intum-field-status ml-2 inline-flex items-center"
        el.insertAdjacentElement("afterend", spinner)
      }
      showSpinner(spinner)
    }

    fetch(url, { method: "POST", headers: { "X-CSRF-Token": csrfToken && csrfToken.content, Accept: "application/json" } })
      .then(function() {
        // zielona fajka znika po 1 s (field_status.js)
        if (el) showSavedCheck(spinner)
        if (options && options.notify) window.IntumJs.notify(options.notify)
      })
  },

  // Przełączanie tabów — użycie: onclick="IntumJs.switchTab('tab_id', this)"
  switchTab: function(tabId, btn) {
    const attr = btn.closest("nav").dataset.tabGroup || "data-tab"
    document.querySelectorAll("[" + attr + "]").forEach(function(el) { el.classList.add("hidden") })
    document.getElementById(tabId).classList.remove("hidden")
    btn.closest("nav").querySelectorAll("button").forEach(function(b) {
      b.classList.remove("border-blue-500", "text-blue-600")
      b.classList.add("border-transparent", "text-gray-500")
    })
    btn.classList.add("border-blue-500", "text-blue-600")
    btn.classList.remove("border-transparent", "text-gray-500")
  },

  // Modal dodawania źródła — krok 2: pokaż elementy wybranego typu
  showAddSourceStep2: function(sourceType) {
    document.getElementById("add_source_step1").classList.add("hidden")
    document.getElementById("add_source_step2").classList.remove("hidden")
    document.querySelectorAll(".add-source-item").forEach(function(el) {
      el.classList.toggle("hidden", el.dataset.sourceType !== sourceType)
    })
  },

  showAddSourceStep1: function() {
    document.getElementById("add_source_step2").classList.add("hidden")
    document.getElementById("add_source_step1").classList.remove("hidden")
  },

  // Kopiuje podany tekst do schowka. Używa nowoczesnego clipboard API
  // z fallbackiem na document.execCommand("copy") dla starszych przeglądarek/HTTP.
  // Opcjonalnie pokazuje krótki komunikat (np. "Skopiowano") w przekazanym elemencie
  // przez 1.5s, po czym przywraca oryginalny tekst — podobnie jak copyMarkdown.
  copyToClipboard: function(text, el, copiedText) {
    const showFeedback = () => {
      if (!el) return
      const target = el.querySelector("span") || el
      const original = target.textContent
      target.textContent = copiedText || "Skopiowano"
      setTimeout(() => { target.textContent = original }, 1500)
    }

    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text)
        .then(showFeedback)
        .catch(() => window.IntumJs._fallbackCopy(text).then(showFeedback))
    }
    return window.IntumJs._fallbackCopy(text).then(showFeedback)
  },

  _fallbackCopy: function(text) {
    const ta = document.createElement("textarea")
    ta.value = text
    ta.style.position = "fixed"
    ta.style.opacity = "0"
    document.body.appendChild(ta)
    ta.select()
    try { document.execCommand("copy") } finally { document.body.removeChild(ta) }
    return Promise.resolve()
  },

  copyMarkdown: function(url, el, copiedText) {
    fetch(url, { headers: { Accept: "text/markdown" } })
      .then(r => r.text())
      .then(t => {
        if (navigator.clipboard) {
          navigator.clipboard.writeText(t)
        } else {
          const ta = document.createElement("textarea")
          ta.value = t
          ta.style.position = "fixed"
          ta.style.opacity = "0"
          document.body.appendChild(ta)
          ta.select()
          document.execCommand("copy")
          document.body.removeChild(ta)
        }
        const target = el.querySelector("span") || el
        const original = target.textContent
        target.textContent = copiedText
        setTimeout(() => { target.textContent = original }, 1500)
      })
  },

  // Wstawia klucz z wartością do pola JSON (textarea) po ID.
  // Jeśli klucz już istnieje w JSON, nie nadpisuje.
  // Jesli textarea jest opakowana w CodeMirror (data-controller=codemirror) - aktualizuje tez editor.
  insertJsonField: function(targetId, key, example) {
    const el = document.getElementById(targetId)
    if (!el) return

    // odczytaj aktualny JSON - z CodeMirror (jesli aktywny) lub z textarea
    const cmWrapper = el.closest("[data-controller='codemirror']")
    const currentRaw = (cmWrapper && cmWrapper.cmView)
      ? cmWrapper.cmView.state.doc.toString()
      : el.value

    let obj = {}
    try { obj = JSON.parse(currentRaw || "{}") } catch (_e) { obj = {} }

    if (obj[key] !== undefined) return // klucz już istnieje

    obj[key] = example
    const json = JSON.stringify(obj, null, 2)
    el.value = json

    // jesli jest CodeMirror - zaktualizuj jego stan zeby textarea i editor byly w synchu
    if (cmWrapper && cmWrapper.cmView) {
      const view = cmWrapper.cmView
      view.dispatch({
        changes: { from: 0, to: view.state.doc.length, insert: json }
      })
    }

    // Triggeruj event input żeby Stimulus/inne listenery odebrały zmianę
    el.dispatchEvent(new Event("input", { bubbles: true }))
  },
}

// hotkeys("ctrl+K", (event, _handler) => {
//   event.preventDefault()
//   toggleSearch()
//   // alert(12)
//   // const archiveAndNextBtn = document.getElementById("archive_and_next")
//   // if (archiveAndNextBtn) {
//   //   archiveAndNextBtn.click()
//   // }
// })

// Globalny spinner na submit buttonach — po wysłaniu formularza disabluje button i dodaje animację
function disableSubmitButton(btn) {
  btn.disabled = true
  btn.classList.add("opacity-50", "cursor-not-allowed")
  if (btn.tagName === "BUTTON" && !btn.querySelector(".submit-spinner")) {
    // Ukryj tekst i nałóż spinner absolutnie — bez zmiany rozmiaru buttona
    btn.style.position = "relative"
    Array.from(btn.childNodes).forEach(c => {
      if (c.nodeType === 1) c.style.visibility = "hidden"
      else if (c.nodeType === 3 && c.textContent.trim()) {
        const wrap = document.createElement("span")
        wrap.style.visibility = "hidden"
        c.parentNode.insertBefore(wrap, c)
        wrap.appendChild(c)
      }
    })
    const spinner = document.createElement("span")
    spinner.className = "submit-spinner animate-spin"
    spinner.style.cssText = "position:absolute;inset:0;display:flex;align-items:center;justify-content:center"
    spinner.innerHTML = "<svg class=\"h-4 w-4\" xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\"><circle class=\"opacity-25\" cx=\"12\" cy=\"12\" r=\"10\" stroke=\"currentColor\" stroke-width=\"4\"></circle><path class=\"opacity-75\" fill=\"currentColor\" d=\"M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z\"></path></svg>"
    btn.appendChild(spinner)
  }
}

// Odwraca disableSubmitButton — używane po `turbo:submit-end`, gdy strona nie robi pełnego reloadu
function enableSubmitButton(btn) {
  btn.disabled = false
  btn.classList.remove("opacity-50", "cursor-not-allowed")
  Array.from(btn.childNodes).forEach(c => {
    if (c.nodeType !== 1) return
    if (c.classList && c.classList.contains("submit-spinner")) {
      c.remove()
    } else {
      c.style.visibility = ""
    }
  })
}

document.addEventListener("submit", (e) => {
  const form = e.target
  if (form.dataset.noSpinner) return
  // walidacja po stronie klienta mogła anulować submit (preventDefault) - wtedy nie ma czego
  // wysyłać ani co odblokowywać (turbo:submit-end nie poleci), więc nie disablujemy przycisku,
  // bo zostałby zablokowany na zawsze
  if (e.defaultPrevented) return
  // data-turbo-confirm: dialog potwierdzenia jest asynchroniczny, a anulowanie nie wysyła
  // formularza (turbo:submit-end nie poleci i spinner zostałby na zawsze) - spinner założy
  // dopiero listener turbo:submit-start, czyli po zaakceptowaniu dialogu.
  // Przy data-turbo="false" Turbo nie obsłuży submitu (ani confirma), więc spinner idzie od razu
  const hasTurboConfirm = form.dataset.turboConfirm || (e.submitter && e.submitter.dataset.turboConfirm)
  if (hasTurboConfirm && form.dataset.turbo !== "false") return
  // Turbo Drive jest wyłączony, więc formularz wysyła sama przeglądarka - a ta serializuje pola
  // dopiero PO zakończeniu zdarzenia submit. Przycisk wyłączony w tym miejscu synchronicznie
  // wypada z danych i serwer nie dostaje `commit=<etykieta>` (np. "Przegeneruj" vs "Skasuj",
  // "Wyślij i zamknij"). Stąd odroczenie o tick: serializacja już za nami, a klik wciąż jest jeden
  setTimeout(() => {
    const buttons = form.querySelectorAll("button[type=\"submit\"], input[type=\"submit\"]")
    buttons.forEach(disableSubmitButton)
    // Obsługa górnego buttona poza formularzem
    document.querySelectorAll(".button_save_top").forEach(disableSubmitButton)
  }, 0)
})

// Formularze z data-turbo-confirm dostają spinner dopiero po zaakceptowaniu dialogu
// (turbo:submit-start leci już po potwierdzeniu). Dla pozostałych form wywołanie jest
// idempotentne - przycisk jest już disabled, a spinner nie duplikuje się
document.addEventListener("turbo:submit-start", (e) => {
  const form = e.target
  if (form.dataset.noSpinner) return
  const buttons = form.querySelectorAll("button[type=\"submit\"], input[type=\"submit\"]")
  buttons.forEach(disableSubmitButton)
  document.querySelectorAll(".button_save_top").forEach(disableSubmitButton)
})

// Submit przez Turbo Stream (local: false z aktywnym Turbo Drive) — brak full reloadu, trzeba zdjąć spinner ręcznie
document.addEventListener("turbo:submit-end", (e) => {
  const form = e.target
  const buttons = form.querySelectorAll("button[type=\"submit\"], input[type=\"submit\"]")
  buttons.forEach(enableSubmitButton)
  document.querySelectorAll(".button_save_top").forEach(enableSubmitButton)
})

// Submit przez @rails/ujs (local: false z Turbo.drive=false, np. format.js w kontrolerze) — analogicznie zdjąć spinner po response
document.addEventListener("ajax:complete", (e) => {
  const form = e.target
  if (!form || form.tagName !== "FORM") return
  const buttons = form.querySelectorAll("button[type=\"submit\"], input[type=\"submit\"]")
  buttons.forEach(enableSubmitButton)
  document.querySelectorAll(".button_save_top").forEach(enableSubmitButton)
})
